import React from "react";
import { VStack } from "@chakra-ui/react";
import GoldlistContainer from "components/GoldlistContainer";
import FancyBearsContainer from "components/FancyBearsContainer";
import Header from "components/Header";
import AssetsProvider from "providers/AssetsProvider";

const HomePage: React.FC = () => (
  <AssetsProvider>
    <Header />
    <VStack gap="8" align="center" pt={12} pb="20">
      <GoldlistContainer />
      <FancyBearsContainer />
    </VStack>
  </AssetsProvider>
);

export default HomePage;
